import { render, staticRenderFns } from "./GerenciaCadastroPlanoPedagogico.vue?vue&type=template&id=6f31a9cb"
import script from "./GerenciaCadastroPlanoPedagogico.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroPlanoPedagogico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports